export enum FileDownloadTypes {
  QUOTE = 'job.quotePdfBase64',
  INVOICE = 'job.invoicePdfBase64',
  QUOTE_SIGNATURE_IMAGE = 'job.quoteSignatureImage',
  SIGNED_QUOTE = 'job.signedQuotePdfBase64',

  DOCUMENT = 'document.standard',
}
